import { usePageHeader } from 'src/hooks/misc';
import FormConditionsPage from './FormConditions.page';

const FormCondition = () => {
  usePageHeader({
    title: 'Form Conditions',
  });

  return (
    <div className={`page-wrapper`}>
      <FormConditionsPage />
    </div>
  );
};

export default FormCondition;
